import { SET_HOME_COMPONENTS } from "../actionTypes/index";

const initialState = {
  home: {},
};

export default function homeReducers(state = initialState, action) {
  switch (action.type) {
    case SET_HOME_COMPONENTS:
      return { ...state, home: action.data };
    default:
      return state;
  }
}
